import { computed } from 'vue'
import { useDisenoPropio, useNotaria2 } from './useNotaria2'

export interface EstiloTexto { color?: string; fondo?: string; fuente?: string; tamano?: string; peso?: string | number; alinear?: string }

/**
 * Estilo de los formularios de contacto (FormNotinOne, FormNotinTwo y FormGuiado).
 * En la plantilla de siempre, el del panel (Titulo/Descripcion/Button.css). En las plantillas 2 a 5,
 * el de la plantilla (variables --n2-* de .n2-raiz): así el formulario sigue el diseño elegido
 * (ref: https://trello.com/c/LccFAOAR). La alineación del panel se respeta en los dos casos.
 */
export function useEstiloFormulario(control: () => any) {
  const enPlantilla = useDisenoPropio()
  const { acento } = useNotaria2()

  const estilo = computed(() => {
    const c = control() ?? {}
    const T = c.Titulo?.css ?? {}, D = c.Descripcion?.css ?? {}, B = c.Button?.css ?? {}
    if (!enPlantilla.value) {
      return {
        enPlantilla: false,
        titulo: { color: T.Color, fondo: T.BackgroundColor, fuente: T.Font, tamano: T.Size, peso: T.Weight, alinear: T.Align } as EstiloTexto,
        descripcion: { color: D.Color, fondo: D.BackgroundColor, fuente: D.Font, tamano: D.Size, peso: D.Weight, alinear: D.Align } as EstiloTexto,
        boton: { color: B.Color, fondo: B.BackgroundColor, fuente: B.Font, tamano: B.Size, peso: B.Weight, alinear: B.Align } as EstiloTexto,
      }
    }
    return {
      enPlantilla: true,
      titulo: { color: 'var(--n2-texto)', fondo: 'transparent', fuente: 'var(--n2-fuente-titulos)', tamano: 'clamp(30px, 3.6vw, 44px)', peso: 'var(--n2-peso-titulos)', alinear: T.Align } as EstiloTexto,
      descripcion: { color: 'var(--n2-texto-suave)', fondo: 'transparent', fuente: 'var(--n2-fuente-texto)', tamano: '18px', peso: 400, alinear: D.Align } as EstiloTexto,
      boton: { color: 'var(--n2-sobre-acento)', fondo: 'var(--n2-acento)', fuente: 'var(--n2-fuente-texto)', tamano: '16px', peso: 600, alinear: B.Align } as EstiloTexto,
    }
  })

  return { enPlantilla, estilo, acentoPlantilla: acento }
}
